import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaYoutube } from 'react-icons/fa';
import whatsapp from '../Accests/whatsapp.png';


const Footer = () => {
    const navLinks = [
        { name: 'Home', path: '/' },
        { name: 'Gallery', path: '/gallery' },
        { name: 'Wellness', path: '/wellness' },
        { name: 'Travel Packages', path: '/travel' },
        { name: 'Ayurvedic Products', path: '/ayurveda' },
        { name: 'Herbal Tea', path: '/tea' },
        { name: 'Bank Info', path: '/bank' },
        { name: 'Fabric Store', path: '/fabric' },
        { name: 'Mask Museum & Antiques', path: '/masks' },
        { name: 'Our Activity', path: '/services' }
    ];

    const handleLinkClick = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <footer className="bg-gray-900 text-white pt-12 pb-6 relative">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                {/* Navigation Links */}
                <nav className="mb-10">
                    <ul className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-y-4 gap-x-4 text-center">
                        {navLinks.map((link) => (
                            <li key={link.name}>
                                <Link
                                    to={link.path}
                                    onClick={handleLinkClick}
                                    className="hover:text-gray-300 transition-colors duration-200"
                                >
                                    {link.name}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </nav>

                {/* Footer Content */}
                <div className="flex flex-col md:flex-row justify-between items-center">
                    {/* Social Media Icons */}
                    <div className="flex space-x-4 mb-6 md:mb-0">
                        <a
                            href="https://www.facebook.com/profile.php?id=61562964720362"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-600 hover:text-white text-2xl"
                        >
                            <FaFacebookF/>
                        </a>
                        <a
                            href="https://www.instagram.com/no_limit_tour_randombe_/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-pink-500 hover:text-white text-2xl"
                        >
                            <FaInstagram/>
                        </a>
                        <a
                            href="https://linkedin.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-700 hover:text-white text-2xl"
                        >
                            <FaLinkedinIn/>
                        </a>
                        <a
                            href="https://youtube.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-red-600 hover:text-white text-2xl"
                        >
                            <FaYoutube/>
                        </a>
                    </div>

                    {/* Contact Section */}
                    <div className="text-center">
                        <h3 className="text-xl font-bold mb-2 ">Get in Touch</h3>
                        <p className="mb-4 max-w-sm">
                            We are always ready to help you. There are many ways to contact us.
                        </p>
                        <a
                            href="https://wa.me/+94776080940?text=Hello, I would like to get in touch with you."
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center justify-center w-48 h-12 bg-blue-700 hover:bg-blue-600 rounded-lg text-white font-medium text-lg transition-all"
                        >
                            Contact
                        </a>
                    </div>
                </div>

                {/* Floating WhatsApp Button (Visible on all screens) */}
                <a
                    href="https://wa.me/+94776080940?text=Hello, I would like to get in touch with you."
                    target="_blank"
                    rel="noopener noreferrer"
                    className="fixed bottom-4 right-4 w-12 h-12 rounded-full bg-green-500 flex items-center justify-center cursor-pointer animate-pulse hover:scale-110 transition-transform z-50"
                >
                    <img src={whatsapp} alt="WhatsApp" className="w-6 h-6"/>
                </a>


                {/* Footer Bottom Text */}
                <div className="text-center text-sm mt-8 border-t border-gray-700 pt-4">
                    © 2025 No Limit Tour Randombe. All Rights Reserved.
                </div>
            </div>
        </footer>
    );
};

export default Footer;
